// src/router/index.js
import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import HomeView from '@/views/HomeView.vue';
import CoreBizView from '@/views/CoreBizView.vue';
import ProjectView from '@/views/ProjectView.vue';
import ProjectInfoView from '@/views/ProjectInfoView.vue';

import NewsView from '@/views/NewsView.vue';
import CultureView from '@/views/CultureView.vue';




const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/core',
    name: 'core',
    component: CoreBizView
  },
  {
    path: '/project',
    name: 'project',
    component: ProjectView
  },
  {
    path: '/projectInfo',
    name: 'projectInfo',
    component: ProjectInfoView
  },
  {
    path: '/news',
    name: 'news',
    component: NewsView
  },
  {
    path: '/culture',
    name: 'culture',
    component: CultureView
  }
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});
export default router;